import { useTranslation } from "react-i18next";
import { useState } from "react";
import useAnimateCss from "../../hooks/useAnimateCss";
import sliderImg1 from "../../assets/images/main-slider/image-01.jpg";
import sliderImg2 from "../../assets/images/main-slider/image-02.jpg";
import sliderImg3 from "../../assets/images/main-slider/image-3.jpg";
import preQualBg from "../../assets/images/background/3.jpg";


const carouselImgs = [
  sliderImg1,
  sliderImg2,
  sliderImg3,
];

function NeedConsultation() {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const eyebrowRef  = useAnimateCss("animate__fadeInDown", 0,   0.15);
  const headingRef  = useAnimateCss("animate__fadeInUp",   120, 0.15);
  const checksRef   = useAnimateCss("animate__fadeInLeft", 250, 0.15);
  const carouselRef = useAnimateCss("animate__zoomIn",     380, 0.12, 700);
  const formRef     = useAnimateCss("animate__fadeInRight",150, 0.12);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    window.location.href = `mailto:info@almadina-steel.com?subject=Consultation Request from ${form.name}&body=Name: ${form.name}%0AEmail: ${form.email}%0APhone: ${form.phone}%0AMessage: ${form.message}`;
  };

  return (
    <section className="consultant-section">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* LEFT — text + checklist + images */}
          <div className="col-lg-6">
            <span className="consultant-eyebrow" ref={eyebrowRef as any}>{t("cta-label")}</span>
            <h2 className="consultant-heading" ref={headingRef as any}>{t("cta-headline")}</h2>

            <div className="consultant-checks" ref={checksRef as any}>
              <span>
                <i className="bi bi-check2" /> {t("cta-support")}
              </span>
              <span>
                <i className="bi bi-check2" /> {t("cta-consultation")}
              </span>
              <span>
                <i className="bi bi-check2" /> {t("cta-experts")}
              </span>
            </div>

            <div className="consult-carousel-wrapper" ref={carouselRef as any}>
              <div className="consult-carousel-track">
                {[...carouselImgs, ...carouselImgs].map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt={`Al Madina Steel ${i + 1}`}
                    className="consult-carousel-img"
                  />
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT — form card */}
          <div className="col-lg-6" ref={formRef as any}>
            <div className="consultant-form-card">
              <form className="consultant-form" onSubmit={handleSubmit}>
                <div className="consultant-field">
                  <label>{t("cex-form-name")}</label>
                  <input
                    type="text"
                    className="consultant-input"
                    placeholder={t("cex-form-name")}
                    title={t("cex-form-name")}
                    value={form.name}
                    onChange={(e) =>
                      setForm((s) => ({ ...s, name: e.target.value }))
                    }
                    required
                  />
                </div>
                <div className="consultant-field">
                  <label>{t("cex-form-email")}</label>
                  <input
                    type="email"
                    className="consultant-input"
                    placeholder={t("cex-form-email")}
                    title={t("cex-form-email")}
                    value={form.email}
                    onChange={(e) =>
                      setForm((s) => ({ ...s, email: e.target.value }))
                    }
                    required
                  />
                </div>
                <div className="consultant-field">
                  <label>{t("cex-form-phone")}</label>
                  <input
                    type="tel"
                    className="consultant-input"
                    placeholder={t("cex-form-phone")}
                    title={t("cex-form-phone")}
                    value={form.phone}
                    onChange={(e) =>
                      setForm((s) => ({ ...s, phone: e.target.value }))
                    }
                  />
                </div>
                <div className="consultant-field">
                  <label>{t("cex-form-message")}</label>
                  <textarea
                    className="consultant-input consultant-textarea"
                    placeholder={t("cex-form-message")}
                    title={t("cex-form-message")}
                    value={form.message}
                    onChange={(e) =>
                      setForm((s) => ({ ...s, message: e.target.value }))
                    }
                  />
                </div>
                <button type="submit" className="consultant-submit">
                  {t("cex-form-send")} &nbsp;
                  <i className="bi bi-arrow-right" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Pre-qualifications bar */}
      {/* <div className="pre-qual-bar" style={{ backgroundImage: `url(${preQualBg})` }}>
        <a
          href="https://drive.google.com/drive/folders/1QxQ3eq0wM-3KxO3xAeyMgu-417Jxru21"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            aria-hidden="true"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z" />
          </svg>
          {t("prequal-link")}
        </a>
      </div> */}
    </section>
  );
}

export default NeedConsultation;
